import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { GetStreamActivities, ActivityStreamEvent, ClearActivityStreamStore } from 'ng2-app/store/activity/activity.actions';
import { ActivityService }  from 'ng2-app/modules/activity/models/activity/activity.service';
import { insertItem, patch, removeItem } from '@ngxs/store/operators';


export class ActivityStreamStateModel {
  loading: boolean;
  activities: Activity[];
}

@Injectable()
@State<ActivityStreamStateModel>({
  name: 'activityStream',
  defaults: {
    loading: false,
    activities: [],
  }
})

export class ActivityStreamState {
  @Selector()
  static activities(state: ActivityStreamStateModel) {
    return state.activities;
  }

  @Selector()
  static loading(state: ActivityStreamStateModel) {
    return state.loading;
  }

  constructor(
    private activityService: ActivityService,
  ) {}

  @Action(GetStreamActivities)
  getStreamActivities(
    { getState, patchState }: StateContext<ActivityStreamStateModel>,
    { criteria, limit, offset, reset }: GetStreamActivities,
  ) {
    const sort = {'activities.created': 'DESC'},
      current = getState().activities;
    const prePatch: any = {
      loading: true,
    };
    if(reset) {
      prePatch.activities = [];
    }
    patchState(prePatch);
    this.activityService.getAll({
      query: {
        criteria,
        limit,
        offset,
        sort,
      }
    }).subscribe( activities => {

      const newActivities = reset
        ? activities
        : [...current, ...activities];

      patchState({
        activities: newActivities,
        loading: false,
      });

    });

  }

  @Action(ActivityStreamEvent)
  newActivityEvent(
    { setState }: StateContext<ActivityStreamStateModel>,
    { activity }: ActivityStreamEvent
  ) {
    const contextFn = (curAct: Activity) => curAct.id === activity.id;
    const activities = activity.deletedTimestamp
      ? removeItem<Activity>(contextFn)
      : insertItem<Activity>(activity);

    setState(patch({
      activities
    }));
  }

  @Action(ClearActivityStreamStore)
  clearActivityStreamStore(
    { patchState }: StateContext<ActivityStreamStateModel>,
    { }: ClearActivityStreamStore
  ) {
    patchState({
      activities: [],
    });
  }
}
